import React, { useState } from "react";
import styled from "@emotion/styled";
import BackHeader from "@components/header/BackHeader";
import KakaoChatButton from "@components/button/KakaoChatButton";
import { useTranslation } from "react-i18next";
import BasicButton from "@components/button/BasicButton";
import { Flex, Typography } from "antd";
import BasicModal from "@components/modal/BasicModal";
import { useTheme } from "@emotion/react";
import Image from "@components/item/Image";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
});

const ContentWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "4rem",
  padding: "1.2rem 2rem",

  ".title": {
    fontSize: "2rem",
    fontWeight: theme.fontWeight.bold,
  },
}));

const DescBox = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  color: theme.color.gray,
  lineHeight: "2.1rem",
}));

const OneInquiry = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [modal, setModal] = useState(false);

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    setModal(true);
  };

  return (
    <Container>
      <BackHeader title="1:1 문의하기" />

      <ContentWrapper>
        <span className="title">{t("고객센터 운영 안내")}</span>
        <DescBox>
          <span>• {t("평일 10:00 - 17:30 (토・일 공휴일 휴무)")}</span>
          <span>• {t("점심시간 12:00 - 13:00")}</span>
          <span>• {t("대표 이메일 : shakalaka.kr@gmail.com")}</span>
        </DescBox>

        <Flex vertical gap={"2rem"}>
          <KakaoChatButton />

          <BasicButton
            height="5.2rem"
            title="이메일 문의"
            onClick={() => copyToClipboard("shakalaka.kr@gmail.com")}
          />
        </Flex>

        <BasicModal open={modal} setOpen={setModal} noButton>
          <Flex gap="2rem" vertical align="center">
            <Image src={theme.image.check_circle.default} size="4.8rem" />
            <span>{t("이메일이 복사되었습니다.")}</span>
          </Flex>
        </BasicModal>
      </ContentWrapper>
    </Container>
  );
};

export default OneInquiry;
